import { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { homeEase } from '../style/homeStyles';

// Fade-in + slide-up cuando el bloque entra en viewport. Se dispara una sola vez.
const Reveal = ({ children, delay, sx }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;

    // Sin IntersectionObserver (o en el prerender) mostramos el contenido directamente.
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(element);
        }
      });
    }, { threshold: 0.15 });

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={ref}
      className={visible ? 'home-reveal in' : 'home-reveal'}
      sx={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(14px)',
        transition: `opacity .8s ${homeEase}, transform .8s ${homeEase}`,
        transitionDelay: `${delay}ms`,
        '@media (prefers-reduced-motion: reduce)': {
          opacity: 1,
          transform: 'none',
          transition: 'none',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

Reveal.propTypes = {
  children: PropTypes.node.isRequired,
  delay: PropTypes.number,
  sx: PropTypes.shape({}),
};

Reveal.defaultProps = {
  delay: 0,
  sx: {},
};

export default Reveal;
